export const LINKS = {
  discord: "https://discord.gg/Nsfru3Rav7",
  buyMeACoffee: "https://buymeacoffee.com/tapestrygames",
  backerkit:
    "https://www.backerkit.com/call_to_action/42742be6-e253-4815-9f20-d835e2d07d85/landing",
  godComplexSite: "https://GodComplexTTRPG.com",
  fatewovenSite: "https://FateWoventtrpg.com",
};

export const LOGOS = {
  godComplex:
    "https://customer-assets.emergentagent.com/job_ttrpg-portal/artifacts/it5pqwl7_GOD_COMPLEX_FINAL.webp",
  // Processed version: gold Celtic knot + FATEWOVEN wordmark on transparent
  // background. See scripts/process_fatewoven_logo.py (v2).
  fatewoven: "/fatewoven-v2.png",
  // Tapestry Games brand assets (processed from user upload: black bg keyed
  // to transparent). Full lockup vs. loom mark only.
  tapestryFull: "/tapestry-logo-full.png",
  tapestryMark: "/tapestry-mark.png",
};

export const BACKGROUNDS = {
  godComplex:
    "https://images.unsplash.com/photo-1495709165577-351d14380bdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMGZhbnRhc3klMjBjaXR5JTIwc3RyZWV0JTIwbmlnaHQlMjBmb2d8ZW58MHx8fHwxNzgzNjI4NzgxfDA&ixlib=rb-4.1.0&q=85",
  fatewoven:
    "https://images.unsplash.com/photo-1519884705082-b505c3001e63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxteXN0ZXJpb3VzJTIwYW5jaWVudCUyMGJvb2slMjBwYWdlcyUyMHZpbnRhZ2V8ZW58MHx8fHwxNzgzNjI4NzgyfDA&ixlib=rb-4.1.0&q=85",
  texture:
    "https://images.unsplash.com/photo-1637004732258-4b792ce8f474?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxkYXJrJTIwd292ZW4lMjBmYWJyaWMlMjB0ZXh0dXJlJTIwbWFjcm98ZW58MHx8fHwxNzgzNjI4NzgyfDA&ixlib=rb-4.1.0&q=85",
};
